// extracted by mini-css-extract-plugin
export default {"content":"FileInputLayout_content__dVlrZ","image":"FileInputLayout_image__hpqZ7"};